export interface ConfidenceSliderProps {
  value: number
  onChange: (value: number) => void
  /** Ghost marker showing a reference value (e.g. the current published threshold). */
  referenceValue?: number
  disabled?: boolean
}

// 0-100% slider with a ghost marker for a reference value.
export function ConfidenceSlider({ value, onChange, referenceValue, disabled }: ConfidenceSliderProps) {
  return (
    <div className="flex flex-col gap-1">
      <div className="relative h-2 w-full rounded-pill bg-surface-raised">
        <div
          className="absolute top-1/2 h-2 -translate-y-1/2 rounded-pill bg-accent"
          style={{ width: `${value}%` }}
          aria-hidden
        />
        {referenceValue !== undefined && (
          // Rendered after (on top of) the fill, so the marker stays visible
          // even when the current value covers or exceeds it - otherwise a
          // value at/above the reference would silently hide the comparison.
          <div
            className="absolute top-1/2 h-3 w-0.5 -translate-y-1/2 bg-text-disabled"
            style={{ left: `${referenceValue}%` }}
            aria-hidden
          />
        )}
        <input
          type="range"
          min={0}
          max={100}
          value={value}
          disabled={disabled}
          onChange={(event) => onChange(Number(event.target.value))}
          className="absolute inset-0 h-2 w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
          aria-valuetext={`${value}%`}
        />
      </div>
      <span className="text-meta text-text-secondary">{value}%</span>
    </div>
  )
}
